import { useCallback, useSyncExternalStore } from 'react';

import useLoggedUser from '@/hooks/useLoggedUser';

import { readIsCustomerViewOn, subscribeToCustomerViewActivity } from './customerViewActivity';
import { clearCustomerViewStartedAtMs, writeCustomerViewStartedAtMs } from './customerViewStorage';

export const useStaffView = () => {
  const { isOneStep: isStaff, myProfile } = useLoggedUser();
  const userUuid = myProfile?.uuid;
  const subscribe = useCallback(
    (listener: () => void) => subscribeToCustomerViewActivity(userUuid, listener),
    [userUuid],
  );
  const isCustomerViewOn = useSyncExternalStore(subscribe, () => readIsCustomerViewOn(userUuid));

  const isCustomerView = isStaff && isCustomerViewOn;

  const turnCustomerViewOn = useCallback(() => {
    if (userUuid) writeCustomerViewStartedAtMs(userUuid, Date.now());
  }, [userUuid]);

  const turnCustomerViewOff = useCallback(() => {
    if (userUuid) clearCustomerViewStartedAtMs(userUuid);
  }, [userUuid]);

  const toggleCustomerView = isCustomerView ? turnCustomerViewOff : turnCustomerViewOn;

  return {
    isStaff,
    isCustomerView,
    showsStaffTools: isStaff && !isCustomerView,
    turnCustomerViewOn,
    turnCustomerViewOff,
    toggleCustomerView,
  };
};
